/* This file was generated automatically. Do not edit manually. */

export enum AccountingExportIntegrationExportAccountingSoftware {
    Acomba = 'Acomba',
    AcombaX = 'AcombaX',
    QuickBooks = 'QuickBooks',
    Sage50 = 'Sage50',
    Avantage = 'Avantage',
}
